// extracted by mini-css-extract-plugin
export default {"container":"PillarsPage_container__qUIvR","mainHeader":"PillarsPage_mainHeader__SC0iZ"};